// globalPoint.js 数据埋点快捷指令
import requestFn from "@/api";
import qs from "querystring";

export default {
  methods: {
    // 调用此方法可以埋点 动作事件：
    czcGlobalPoint(phone = "", action = "", actionremark = "", tool = "", errdetail = "") {
      let query = qs.parse(location.search.replace("?", "").replace(/\/.*/g, ""));
      requestFn.insertTcmInternetUseraction({
        useruid: phone || "",
        mark: action || "",
        actionremark: actionremark || "",
        advertool: tool || "TikTok",  // 投放工具 H5:H5页面 TikTok:抖音小程序 青年版youthVersion 中年版middleVersion 老年版oldVersion
        channeluid: query.useruid || "",
        errdetail: errdetail || ""  // 错误详情
      }).then(res => {
        console.log(action + actionremark);
      }).catch(err => {
        console.log(err);
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/globalPoint.js